/**
 * Owner ruling R20 (6 Aug 2026): the product name is a single configurable
 * constant. ONE source feeds UI, emails, PDFs and page titles, so renaming the
 * product is a one-line change here rather than a repo-wide sweep.
 *
 * The working name is currently "Bousala" but is TENTATIVE, pending domain
 * availability. Per R20(a) the documents and this build stay on "PalAccount"
 * until the name is final — then one rename sweep, not repeated churn.
 *
 * Never hard-code the product name anywhere else. Import `BRAND` instead.
 */
export const BRAND = {
    /** Product name as shown to users. The single source of truth (R20). */
    name: 'PalAccount',
    /** Short name for tight spaces (nav collapse, mobile title bar). */
    shortName: 'PalAccount',
    /** Appended to browser/document titles, e.g. "Invoices · PalAccount". */
    titleSuffix: 'PalAccount',
    /** Legal entity shown on generated PDFs and email footers. */
    legalName: 'PalAccount',
};
/** Builds a document title, e.g. `pageTitle('Invoices')` → "Invoices · PalAccount". */
export function pageTitle(page) {
    return page ? `${page} · ${BRAND.titleSuffix}` : BRAND.name;
}
//# sourceMappingURL=brand.js.map